const normalizeModes = (headModes) => {
  const modes = Array.isArray(headModes) ? headModes : ['refreshTop'];
  return new Set(modes.map((mode) => String(mode || '').trim()).filter(Boolean));
};

export const resolveEventListUrl = ({
  mode = 'reset',
  offset = 0,
  headUrl,
  pageUrlBuilder,
  headModes = ['refreshTop'],
} = {}) => {
  const safeMode = String(mode || 'reset').trim();
  const useHead = normalizeModes(headModes).has(safeMode);
  if (useHead) return headUrl;
  return typeof pageUrlBuilder === 'function' ? pageUrlBuilder(offset) : '';
};

export const loadEventListRows = async ({
  mode = 'reset',
  offset = 0,
  headUrl,
  pageUrlBuilder,
  headModes = ['refreshTop'],
  fetchJsonSafe = null,
  errorLabel = '',
  requestInit = {},
} = {}) => {
  const url = resolveEventListUrl({
    mode,
    offset,
    headUrl,
    pageUrlBuilder,
    headModes,
  });
  if (!url) return { url: '', events: [] };

  if (typeof fetchJsonSafe === 'function') {
    try {
      const { events = [] } = await fetchJsonSafe(url, requestInit, { label: errorLabel });
      return { url, events: Array.isArray(events) ? events : [] };
    } catch (error) {
      if (error?.status === 403) {
        return { url, status: 403, ok: false, forbidden: true, events: [], data: {} };
      }
      throw error;
    }
  }

  return { url, events: [] };
};
